import { useTranslations } from 'next-intl'
import styles from './WindowsModal.module.css'
import { useGamepadConnect } from '@/hooks/useGamepadConnect'
import AppLink from '@/components/UI/Links/AppLink/AppLink'
import { windowsClientDownload } from '@/utils/data'


export default function WindowsModal({ callback }: { callback: () => void}) {

    const t = useTranslations('Modals.Windows')


    return (
        <div className={styles.main} data-testid="Game_windowsModal">
            <div className={styles.text}>
                <h2>{t('title', { siteName: process.env.NEXT_PUBLIC_SITENAME as string })}</h2>
            </div>
            <p>{t.rich('download', {
            windowsLink: (chunks) => <AppLink internal={false} highlight={true} onClick={callback} href={windowsClientDownload}>{chunks}</AppLink>,
            })}</p>
        </div>
    )
}